import React, { ReactNode } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const VerticalGuard = ({ children }: { children: ReactNode }) => {

  const params = useParams();
  const vertical = params.vertical;
  const { user } = useAuth();
  console.log("VerticalGuard", {
    verticalFromUrl: vertical,
    userVerticalKey: user?.vertical_key,
    role: user?.role,
  });

  // not logged in
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 🔥 ADMIN USER → allow ALL verticals (NO checks)
  if (user.vertical_key === null) {
    return <>{children}</>;
  }

  // normal user → must match own vertical
  if (vertical && vertical !== user.vertical_key) {
    return <Navigate to={`/${user.vertical_key}/inquiries`} replace />;
  }

  return <>{children}</>;
};

export default VerticalGuard;
